import {
  defaultDesignMaterialParams,
  defaultLayerParams,
  defaultMaskParams,
  defaultSdfCommonParams,
  defaultSdfDistortion,
  defaultSdfPattern,
  defaultSdfRandomTilesParams,
  MAX_SDF_PATTERNS,
} from "./designMaterialDefaults";
import type { DesignMaterialParams, SdfPattern } from "./designMaterialTypes";

export function cloneDefaultMaterialParams(): DesignMaterialParams {
  const sdfPatterns: SdfPattern[] = [];
  for (let i = 0; i < MAX_SDF_PATTERNS; ++i) {
    const pattern: SdfPattern = { ...defaultSdfPattern, maskRandomSeedIndex: i };
    if (i === 0) {
      pattern.enabled = true;
    }
    sdfPatterns.push(pattern);
  }
  return {
    ...defaultDesignMaterialParams,

    compatibleLayerConfigLibraries: [],
    compatibleColorLibraries: [],

    sdf: {
      common: { ...defaultSdfCommonParams },
      randomTiles: { ...defaultSdfRandomTilesParams },
      distortions: [{ ...defaultSdfDistortion }, { ...defaultSdfDistortion }, { ...defaultSdfDistortion }],
      patterns: sdfPatterns,
    },

    layers: [
      { ...defaultLayerParams },
      { ...defaultLayerParams },
      { ...defaultLayerParams },
      { ...defaultLayerParams },
    ],
    masks: [{ ...defaultMaskParams }, { ...defaultMaskParams }, { ...defaultMaskParams }, { ...defaultMaskParams }],
  };
}
